import { render, staticRenderFns } from "./DestinationGeneral.vue?vue&type=template&id=834a1ba8&scoped=true&"
import script from "./DestinationGeneral.vue?vue&type=script&lang=js&"
export * from "./DestinationGeneral.vue?vue&type=script&lang=js&"
import style0 from "./DestinationGeneral.vue?vue&type=style&index=0&id=834a1ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834a1ba8",
  null
  
)

export default component.exports